import { effLevel } from "./config";

const Z = (type, look, label, r) => ({ type, look, label, r });
export const HAZARDS = {
  kitchen: [Z("fall", "fork", "FALLING FORKS", 9), Z("roll", "egg", "ROLLING EGGS", 11)],
  jungle: [Z("fall", "coconut", "FALLING COCONUTS", 11), Z("burst", "vine", "SNAPPING VINES", 20)],
  beach: [Z("roll", "coconut", "ROLLING COCONUTS", 11), Z("burst", "water", "WATER SPOUTS", 20)],
  mountains: [Z("roll", "boulder", "ROLLING BOULDERS", 15), Z("fall", "rock", "FALLING ROCKS", 10)],
  swamp: [Z("burst", "toxic", "TOXIC BUBBLES", 20), Z("fall", "spore", "SPORE DROPS", 10)],
  desert: [Z("roll", "tumbleweed", "TUMBLEWEEDS", 13), Z("burst", "sand", "SAND GEYSERS", 20)],
  snow: [Z("fall", "icicle", "FALLING ICICLES", 9), Z("roll", "snowball", "ROLLING SNOWBALLS", 13)],
  volcano: [Z("burst", "lava", "LAVA BURSTS", 20), Z("fall", "ember", "FALLING EMBERS", 10)],
  city: [Z("burst", "steam", "STEAM VENTS", 20), Z("fall", "pot", "FALLING FLOWER POTS", 11)],
  space: [Z("fall", "meteor", "METEOR SHOWERS", 12), Z("burst", "plasma", "PLASMA PILLARS", 20)],
};

export const hazardFor = (kind) => {
  const list = HAZARDS[kind];
  return list ? { list, label: list.map((z) => z.label).join(" & ") } : null;
};
export const pickHazard = (hz) => hz.list[Math.floor(Math.random() * hz.list.length)];
export const hazardInterval = (L, d) => Math.max(2, 5.2 - effLevel(L) * 0.25) / Math.sqrt(d.spawnRate) * (d.spawnRate < 0.5 ? 1.5 : 1) * (L === 1 ? 1.5 : 1);

const OUT = "#4A2511";
const BURST_COL = { lava: ["#F97316", "#FDE047"], toxic: ["#65A30D", "#D9F99D"], steam: ["#CBD5E1", "#F8FAFC"], jam: ["#7E22CE", "#D8B4FE"], vine: ["#15803D", "#86EFAC"], water: ["#0284C7", "#BAE6FD"], sand: ["#C2853A", "#FDE68A"], plasma: ["#A21CAF", "#F0ABFC"] };
export const burstColors = (look) => BURST_COL[look];
const POP_COL = { coconut: "#7C4A1E", boulder: "#8B8478", tumbleweed: "#A16207", icicle: "#BAE6FD", meteor: "#F97316", crumbdrop: "#B45309", spore: "#10B981", ember: "#F97316", fork: "#CBD5E1", egg: "#FEF3C7", rock: "#8B8478", snowball: "#F8FAFC", pot: "#C2410C" };
export const hazardColor = (look) => POP_COL[look] || BURST_COL[look][0];

const circle = (c, x, y, r) => { c.beginPath(); c.arc(x, y, r, 0, Math.PI * 2); };

const drawObject = (c, h, t) => {
  const { x, y, r, look } = h;
  c.save(); c.translate(x, y);
  c.lineWidth = 2.5; c.strokeStyle = OUT;
  if (look === "coconut") {
    c.rotate(h.rot || 0);
    circle(c, 0, 0, r); c.fillStyle = "#7C4A1E"; c.fill(); c.stroke();
    c.strokeStyle = "#5A3212"; c.lineWidth = 1.5;
    for (let i = 0; i < 5; i++) { const a = i * 1.25; c.beginPath(); c.moveTo(Math.cos(a) * r * 0.3, Math.sin(a) * r * 0.3); c.lineTo(Math.cos(a) * r * 0.85, Math.sin(a) * r * 0.85); c.stroke(); }
    c.fillStyle = "#2B1608"; [[-0.3, -0.35], [0.3, -0.35], [0, 0.15]].forEach(([dx, dy]) => { circle(c, dx * r, dy * r, r * 0.14); c.fill(); });
  } else if (look === "egg") {
    c.rotate(h.rot || 0);
    c.beginPath(); c.ellipse(0, 0, r * 0.85, r, 0, 0, Math.PI * 2); c.fillStyle = "#FFF7E6"; c.fill(); c.stroke();
    c.fillStyle = "rgba(255,255,255,0.9)"; circle(c, -r * 0.3, -r * 0.4, r * 0.2); c.fill();
  } else if (look === "snowball") {
    c.rotate(h.rot || 0);
    circle(c, 0, 0, r); c.fillStyle = "#F8FAFC"; c.fill(); c.strokeStyle = "#64748B"; c.stroke();
    c.fillStyle = "#CBD5E1"; circle(c, r * 0.3, r * 0.25, r * 0.3); c.fill(); circle(c, -r * 0.4, r * 0.1, r * 0.15); c.fill();
  } else if (look === "fork") {
    c.fillStyle = "#CBD5E1"; c.strokeStyle = "#334155"; c.lineWidth = 1.8;
    c.beginPath(); c.roundRect(-2.5, -r * 2.4, 5, r * 1.8, 2); c.fill(); c.stroke();
    c.beginPath(); c.roundRect(-r * 0.75, -r * 0.7, r * 1.5, r * 0.5, 2); c.fill(); c.stroke();
    [-0.6, 0, 0.6].forEach((k) => { c.beginPath(); c.moveTo(k * r - 1.5, -r * 0.25); c.lineTo(k * r, r * 1.1); c.lineTo(k * r + 1.5, -r * 0.25); c.closePath(); c.fill(); c.stroke(); });
  } else if (look === "pot") {
    c.fillStyle = "#16A34A"; [[-5, -r - 4], [0, -r - 8], [5, -r - 4]].forEach(([dx, dy]) => { circle(c, dx, dy, 4); c.fill(); });
    c.fillStyle = "#F472B6"; circle(c, 0, -r - 9, 3); c.fill();
    c.beginPath(); c.moveTo(-r, -r * 0.7); c.lineTo(r, -r * 0.7); c.lineTo(r * 0.7, r); c.lineTo(-r * 0.7, r); c.closePath(); c.fillStyle = "#C2410C"; c.fill(); c.stroke();
    c.fillStyle = "#9A3412"; c.fillRect(-r * 1.05, -r * 0.9, r * 2.1, r * 0.4);
  } else if (look === "boulder" || look === "crumbdrop" || look === "rock") {
    c.rotate(h.rot || 0);
    c.beginPath();
    [1, 0.85, 1.05, 0.9, 1, 0.82, 0.97, 0.9].forEach((k, i) => { const a = (i / 8) * Math.PI * 2; c.lineTo(Math.cos(a) * r * k, Math.sin(a) * r * k); });
    c.closePath(); c.fillStyle = look === "boulder" ? "#8B8478" : "#C2721F"; c.fill(); c.stroke();
    c.strokeStyle = "#5E584F"; c.lineWidth = 1.5;
    c.beginPath(); c.moveTo(-r * 0.5, -r * 0.2); c.lineTo(0, r * 0.1); c.lineTo(r * 0.3, -r * 0.4); c.stroke();
    c.fillStyle = "rgba(255,255,255,0.35)"; circle(c, -r * 0.35, -r * 0.45, r * 0.2); c.fill();
  } else if (look === "tumbleweed") {
    c.rotate(h.rot || 0);
    c.strokeStyle = "#A16207"; c.lineWidth = 2;
    for (let i = 0; i < 7; i++) { c.beginPath(); c.ellipse(0, 0, r, r * 0.45, i * 0.45, 0, Math.PI * 2); c.stroke(); }
    c.strokeStyle = "#713F12"; c.lineWidth = 1.5; circle(c, 0, 0, r); c.stroke();
  } else if (look === "icicle") {
    c.beginPath(); c.moveTo(-r, -r * 1.6); c.lineTo(r, -r * 1.6); c.lineTo(0, r * 1.8); c.closePath();
    c.fillStyle = "#BAE6FD"; c.fill(); c.strokeStyle = "#0C4A6E"; c.stroke();
    c.fillStyle = "rgba(255,255,255,0.8)"; c.beginPath(); c.moveTo(-r * 0.5, -r * 1.4); c.lineTo(-r * 0.15, -r * 1.4); c.lineTo(-r * 0.1, r * 0.6); c.closePath(); c.fill();
  } else if (look === "spore") {
    for (let i = 0; i < 8; i++) { const a = i * 0.785 + t * 2; circle(c, Math.cos(a) * r * 0.75, Math.sin(a) * r * 0.75, r * 0.4); c.fillStyle = "#34D399"; c.fill(); }
    circle(c, 0, 0, r * 0.8); c.fillStyle = "#047857"; c.fill(); c.stroke();
    c.fillStyle = "#A7F3D0"; circle(c, -r * 0.25, -r * 0.25, r * 0.2); c.fill();
  } else if (look === "ember") {
    c.fillStyle = "rgba(253,224,71,0.5)"; c.beginPath(); c.ellipse(0, -r * 1.4, r * 0.6, r * 1.6, 0, 0, Math.PI * 2); c.fill();
    circle(c, 0, 0, r * 0.85); c.fillStyle = "#F97316"; c.fill(); c.strokeStyle = "#7C2D12"; c.stroke();
    c.fillStyle = "#FEF08A"; circle(c, -r * 0.2, -r * 0.2, r * 0.35); c.fill();
  } else if (look === "meteor") {
    const a = Math.atan2(-(h.vy || 1), -(h.vx || 0));
    c.fillStyle = "rgba(251,146,60,0.55)";
    c.beginPath(); c.moveTo(Math.cos(a + 1.3) * r, Math.sin(a + 1.3) * r); c.lineTo(Math.cos(a) * r * 4, Math.sin(a) * r * 4); c.lineTo(Math.cos(a - 1.3) * r, Math.sin(a - 1.3) * r); c.closePath(); c.fill();
    circle(c, 0, 0, r); c.fillStyle = "#57534E"; c.fill(); c.strokeStyle = "#F97316"; c.stroke();
    c.fillStyle = "#292524"; circle(c, -r * 0.3, -r * 0.2, r * 0.25); c.fill(); circle(c, r * 0.35, r * 0.3, r * 0.18); c.fill();
  }
  c.restore();
};

const warnMark = (c, x, y, t) => {
  if (Math.sin(t * 18) < -0.2) return;
  c.font = '20px "Lilita One", sans-serif'; c.textAlign = "center";
  c.lineWidth = 4; c.strokeStyle = OUT; c.strokeText("!", x, y); c.fillStyle = "#EF4444"; c.fillText("!", x, y);
};

const drawBurstSide = (c, h, t) => {
  const [dark, light] = BURST_COL[h.look];
  if (h.t < h.warn) {
    const k = h.t / h.warn;
    c.fillStyle = dark; c.globalAlpha = 0.45 + k * 0.4;
    c.beginPath(); c.ellipse(h.x, h.y + 2, 16 + k * 6, 5, 0, 0, Math.PI * 2); c.fill();
    c.fillStyle = light;
    for (let i = 0; i < 3; i++) { circle(c, h.x - 10 + i * 10, h.y - ((t * 30 + i * 9) % 14), 2.5); c.fill(); }
    c.globalAlpha = 1;
    warnMark(c, h.x, h.y - 26, t);
    return;
  }
  const k = Math.min(1, (h.t - h.warn) / 0.15), ht = 120 * k;
  const g = c.createLinearGradient(0, h.y - ht, 0, h.y);
  g.addColorStop(0, light); g.addColorStop(1, dark);
  c.fillStyle = g; c.globalAlpha = h.look === "steam" ? 0.75 : 0.95;
  c.beginPath(); c.roundRect(h.x - 15, h.y - ht, 30, ht, 14); c.fill();
  for (let i = 0; i < 4; i++) { circle(c, h.x + Math.sin(t * 9 + i * 2) * 16, h.y - ht + ((t * 80 + i * 25) % ht), 5); c.fill(); }
  c.globalAlpha = 1;
};

const drawBurstTop = (c, h, t) => {
  const [dark, light] = BURST_COL[h.look];
  if (h.t < h.warn) {
    const k = h.t / h.warn;
    c.globalAlpha = 0.3 + k * 0.4; c.fillStyle = dark; circle(c, h.x, h.y, h.r * (0.5 + k * 0.6)); c.fill();
    c.globalAlpha = 1; c.strokeStyle = "#EF4444"; c.lineWidth = 2; circle(c, h.x, h.y, h.r + 4); c.stroke();
    return;
  }
  c.globalAlpha = 0.85; c.fillStyle = dark; circle(c, h.x, h.y, h.r + 4); c.fill();
  c.fillStyle = light;
  for (let i = 0; i < 6; i++) { const a = i + t * 6; circle(c, h.x + Math.cos(a) * h.r * 0.6, h.y + Math.sin(a) * h.r * 0.6, 5); c.fill(); }
  c.globalAlpha = 1;
};

export const drawHazard = (c, h, t, topDown = false) => {
  if (h.type === "burst") return topDown ? drawBurstTop(c, h, t) : drawBurstSide(c, h, t);
  if (h.type === "fall" && h.t < h.warn) {
    if (topDown) {
      const k = h.t / h.warn;
      c.fillStyle = `rgba(0,0,0,${0.2 + k * 0.3})`; c.beginPath(); c.ellipse(h.x, h.y, h.r * (0.6 + k), h.r * (0.4 + k * 0.5), 0, 0, Math.PI * 2); c.fill();
      if (k > 0.65) drawObject(c, { ...h, y: h.y - (1 - k) * 260 }, t);
      else warnMark(c, h.x, h.y - 10, t);
      return;
    }
    if (h.look === "icicle") drawObject(c, { ...h, x: h.x + Math.sin(t * 50) * 1.5 }, t);
    warnMark(c, h.x, Math.max(28, h.y + 34), t);
    return;
  }
  if (h.type === "roll" && h.t < (h.warn || 0)) { warnMark(c, h.x, h.y - h.r - 8, t); c.globalAlpha = 0.5; drawObject(c, h, t); c.globalAlpha = 1; return; }
  drawObject(c, h, t);
};
